import React from 'react';
import {
  Box,
  Heading,
  Flex,
  Text,
  Icon,
  IconButton,
  Collapse,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { FaClock, FaHistory } from 'react-icons/fa';

const OwnerHistoryCard = () => {
  const [isOpen, setIsOpen] = React.useState(true);
  const toggleCollapse = () => setIsOpen(!isOpen);
  const bg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <Box
      borderWidth="1px"
      borderColor="gray.300"
      borderRadius="md"
      overflow="hidden"
      bg={bg}
      boxShadow="sm"
    >
      {/* Header */}
      <Flex
        justify="space-between"
        align="center"
        bg="#212e89"
        color="white"
        px={4}
        py={2}
      >
        <Flex align="center" gap={4}>
          <Heading size={{ base: "md", md: "lg" }} fontWeight="semibold">
            Vehicle Ownership History
          </Heading>
          <Icon as={FaHistory} boxSize={8} />
        </Flex>
        <IconButton
          size="sm"
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          onClick={toggleCollapse}
          variant="ghost"
          color="white"
          _hover={{ bg: 'blue.600' }}
          aria-label="toggle"
        />
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <Box p={6}>
          <VStack spacing={6} align="center">
            <Icon as={FaClock} boxSize={16} color="blue.400" />
            <VStack spacing={2} align="center">
              <Text fontSize="2xl" fontWeight="bold" color="blue.600">
                Coming Soon
              </Text>
              <Text
                fontSize="md"
                color={textColor}
                textAlign="center"
                maxW="300px"
              >
                Ownership history and detailed vehicle records will be available
                soon. We're working hard to bring you comprehensive vehicle
                information.
              </Text>
            </VStack>
          </VStack>
        </Box>
      </Collapse>
    </Box>
  );
};

export default OwnerHistoryCard;
